export function getAuthRedirectParams(search = window.location.search) {
	const queryParams = new URLSearchParams(search);

	return {
		redirectUri: queryParams.get("redirect_uri"),
		state: queryParams.get("state"),
	};
}

export function buildPathWithAuthRedirect(path, params = {}) {
	const searchParams = new URLSearchParams();
	const redirectUri = params.redirectUri ?? null;
	const state = params.state ?? null;

	if (redirectUri) {
		searchParams.set("redirect_uri", redirectUri);
	}

	if (state) {
		searchParams.set("state", state);
	}

	const queryString = searchParams.toString();

	return queryString ? `${path}?${queryString}` : path;
}

export function redirectWithAuthTokens({
	redirectUri,
	idToken,
	accessToken,
	refreshToken,
	state,
}) {
	if (!redirectUri || !idToken) {
		return false;
	}

	try {
		const redirectUriUrl = new URL(redirectUri);

		redirectUriUrl.searchParams.append("id_token", idToken);
		redirectUriUrl.searchParams.append("access_token", accessToken);
		redirectUriUrl.searchParams.append("refresh_token", refreshToken);

		if (state) {
			redirectUriUrl.searchParams.append("state", state);
		}

		window.location.replace(redirectUriUrl.toString());
		return true;
	} catch (error) {
		console.error("Error parsing redirect_uri:", error);
		return false;
	}
}
